import React, { Component } from 'react'
import { getAttributes } from '../utils/models'

export default (WrappedComponent) => {

    return class extends Component {

        render() {
            const attributes = getAttributes(this.props.model)

            return <WrappedComponent attributes={attributes} {...this.props} />
        }

    }

}


// WEBPACK FOOTER //
// ./src/hocs/withAttributes.js